/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
export type CreditAppSavedSectionInfo_CreditApplication_savedSectionsInfo_SavedSectionsInfo = { readonly __typename: 'SavedSectionsInfo', readonly sectionName: _Types.SectionName, readonly completedAt: any | null, readonly completionStatus: _Types.CompletionStatus | null };

export type CreditAppSavedSectionInfo = { readonly __typename: 'CreditApplication', readonly savedSectionsInfo: ReadonlyArray<CreditAppSavedSectionInfo_CreditApplication_savedSectionsInfo_SavedSectionsInfo | null> | null };

export const CreditAppSavedSectionInfo = gql`
    fragment CreditAppSavedSectionInfo on CreditApplication {
  savedSectionsInfo {
    sectionName
    completedAt
    completionStatus
  }
}
    `;